var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import PropTypes from 'prop-types';
import LogoutLink from './LogoutLink';
import Counter from '../common/Counter';
import BizTag from './BizTag';
import { Message } from '@aperza/ui';
import TdLink from '../common/TdLink';
import { AppService } from '@aperza/util';
const appConfig = AppService.appConfig();
import { target } from 'react-aim';
// @ts-ignore
let UserMenuList = class UserMenuList extends React.Component {
    render() {
        let { viewer } = this.props;
        return (React.createElement("div", { className: "userMenuList" },
            React.createElement("div", { className: "userName" },
                React.createElement(TdLink, { action: "usermenu_mytop", href: `https://account${appConfig.baseComDomain}/`, anchorMessageId: "userMenu.name", anchorMessageValue: { name: viewer.displayName } },
                    React.createElement("p", { className: "name" },
                        React.createElement(Message, { messageId: "userMenu.name", values: { name: viewer.displayName } }))),
                viewer.isBusiness && viewer.companyName && (React.createElement("p", { className: "company" }, viewer.companyName))),
            React.createElement("div", { className: "menuList" },
                React.createElement(TdLink, { className: "menuItem td-click", action: "usermenu_clip", href: `https://account${appConfig.baseComDomain}/clip`, anchorMessageId: "userMenu.clip.title" },
                    React.createElement("p", { className: "title" },
                        React.createElement(Message, { messageId: "userMenu.clip.title" })),
                    React.createElement("p", { className: "caption" },
                        React.createElement(Message, { messageId: "userMenu.clip.caption" }))),
                React.createElement(TdLink, { className: "menuItem td-click", action: "usermenu_history", href: `https://account${appConfig.baseComDomain}/history`, anchorMessageId: "userMenu.history.title" },
                    React.createElement("p", { className: "title" },
                        React.createElement(Message, { messageId: "userMenu.history.title" })),
                    React.createElement("p", { className: "caption" },
                        React.createElement(Message, { messageId: "userMenu.history.caption" }))),
                React.createElement(TdLink, { className: "menuItem td-click", action: "usermenu_mail", href: `https://account${appConfig.baseComDomain}/mail`, anchorMessageId: "userMenu.mail.title" },
                    React.createElement("p", { className: "title" },
                        React.createElement(Message, { messageId: "userMenu.mail.title" })),
                    React.createElement("p", { className: "caption" },
                        React.createElement(Message, { messageId: "userMenu.mail.caption" }))),
                React.createElement(TdLink, { className: "menuItem td-click", action: "usermenu_account", href: `https://account${appConfig.baseComDomain}/account`, anchorMessageId: "userMenu.account.title" },
                    React.createElement("p", { className: "title" },
                        React.createElement(Message, { messageId: "userMenu.account.title" })),
                    React.createElement("p", { className: "caption" },
                        React.createElement(Message, { messageId: "userMenu.account.caption" }))),
                React.createElement(TdLink, { className: "menuItem td-click", action: "usermenu_message", href: `https://${appConfig.baseCluezMemberDomain}/${viewer.locale}/message/list`, anchorMessageId: "userMenu.message.title", openOnNewTab: true },
                    React.createElement("p", { className: "title" },
                        React.createElement(Message, { messageId: "userMenu.message.title" }),
                        "\u00A0",
                        viewer.unreadMessageCount > 0 && React.createElement(Counter, { count: viewer.unreadMessageCount })),
                    React.createElement("p", { className: "caption" },
                        React.createElement(Message, { messageId: "userMenu.message.caption" }))),
                viewer.isBusiness && (React.createElement(TdLink, { className: "menuItem td-click", action: "usermenu_biz", href: `https://dx${appConfig.baseComDomain}/home/index.html`, anchorMessageId: "userMenu.marketing.title" },
                    React.createElement("p", { className: "title" },
                        React.createElement(Message, { messageId: "userMenu.marketing.title" }),
                        "\u00A0",
                        React.createElement(BizTag, null)),
                    React.createElement("p", { className: "caption" },
                        React.createElement(Message, { messageId: "userMenu.marketing.caption" })))),
                viewer.isActiveBusiness && (React.createElement(TdLink, { className: "menuItem td-click", action: "usermenu_biz", href: `https://business${appConfig.baseComDomain}/f/order/index.html`, anchorMessageId: "userMenu.bizAccount.title" },
                    React.createElement("p", { className: "title" },
                        React.createElement(Message, { messageId: "userMenu.bizAccount.title" }),
                        "\u00A0",
                        React.createElement(BizTag, null)),
                    React.createElement("p", { className: "caption" },
                        React.createElement(Message, { messageId: "userMenu.bizAccount.caption" }))))),
            React.createElement(LogoutLink, null)));
    }
};
UserMenuList.propTypes = {
    viewer: PropTypes.any.isRequired,
};
UserMenuList = __decorate([
    target()
], UserMenuList);
export default UserMenuList;
